import axios from "axios";
import { API_ADDRESS } from "../../constants/config";

export class FoundationAddressesService {
  public fetchFoundationAddresses = async () => {
    try {
      const { data } = await axios.get(
        `${API_ADDRESS}/public/contract/foundation-addresses`
      );
      return data;
    } catch (e) {
      console.log(e);
      throw Error(e.message);
    }
  };
}
